<template>
  <div :class="rootClass">
    <b-row>
      <b-col cols="12">
        <b-row class="mb-2">
          <b-col lg="3" sm="12">
            <b-row align-v="center">
              <label :class="rootClass + '__phone-number-label'">Số thuê bao</label>
              <b-form-input
                  ref="inputSearchPhone"
                  v-model="searchPhone"
                  :class="rootClass + '__phone-number-input'"
                  v-on:keyup.enter="getCdrByMonth"
              ></b-form-input>
            </b-row>
          </b-col>
          <b-col lg="3" sm="12" style="margin-left: -2%;">
            <b-row align-v="center">
              <label :class="rootClass + '__month-label'">Tháng</label>
              <input
                  type="month"
                  v-model="month"
                  :class="rootClass + '__month-input'"
                  style="font-size: 16px;font-weight: 500;color: black;padding: 0.375rem 0.75rem;border: 1px solid #ced4da;border-radius: 0.25rem;"
              />
            </b-row>
          </b-col>
          <b-col lg="2" sm="12" style="display: flex; align-items: center">
            <b-button
                :class="rootClass + '__search-btn'"
                class="redButton"
                variant="danger"
                @click="getCdrByMonth"
            >Tra cứu
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <span style="color: red">{{ resultMessage }}</span>
        </b-row>
        <b-row class="mb-1">
          <table :class="rootClass + '__history-table'">
            <tr style="height: 3rem;position: sticky">
              <template v-for="(h, i) in tableFields">
                <th
                    :key="h.key"
                    :class="{
                      '--first-th': i === 0,
                      '--last-th': i === tableFields.length - 1,
                    }"
                    style="min-width: 120px"
                >
                  {{ h.label }}
                </th>
              </template>
            </tr>
            <template v-for="(r,index) in cdrData" v-if="showErrSearch===false">
              <tr :key="index" style="color:black;">
                <td>{{ r.STT }}</td>
                <td>{{ r.Dich }}</td>
                <td>{{ r.NgayThang }}</td>
                <td>{{ r.Loai }}</td>
                <td>{{ r.ThoiGian }}</td>
                <td>{{ r.SoTien }}</td>
              </tr>
            </template>
          </table>
        </b-row>
        <b-row v-if="showErrSearch" style="justify-content: center;font-size: 18px">
          Không tìm thấy kết quả!
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BFormInput,
  BRow,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment/moment";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,
  },
  data() {
    return {
      rootClass: "cdr-by-month",
      searchPhone: "",
      month: moment().format("YYYY-MM"),
      regex087: /87\d{7}$/,
      showErrSearch: false,
      cdrData: [],
      resultMessage: "",
      tableFields: [
        {key: "stt", label: "STT"},
        {key: "dich", label: "Đích"},
        {key: "ngayThang", label: "Ngày tháng"},
        {key: "loai", label: "Loại"},
        {key: "thoiGian", label: "Thời gian (s)"},
        {key: "soTien", label: "Số tiền"},
      ]
    };
  },
  props: {
    searchPhone: String
  },
  mounted() {
    if (this.searchPhone) {
      this.getCdrByMonth();
    }
  },
  methods: {
    formatPhoneNum() {
      if (this.searchPhone.startsWith("0")) {
        this.searchPhone = this.searchPhone.substring(1);
        this.searchPhone = 84 + this.searchPhone;
      }
    },
    getCdrByMonth() {
      this.showLoading("block")
      this.formatPhoneNum();

      if (!this.month) {
        this.showLoading("none")
        this.$toast.error("Vui lòng chọn tháng", {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
        return;
      }

      if (moment().startOf('month').diff(moment(this.month, "YYYY-MM"), 'months') > 2) {
        this.showLoading("none")
        this.$toast.error("Bạn không thể truy xuất dữ liệu quá 3 tháng!", {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
        return;
      }

      // Format tháng từ YYYY-MM sang MM/YYYY
      const monthFormatted = moment(this.month, "YYYY-MM").format("MM/YYYY");

      if (this.regex087.test(this.searchPhone)) {
        useJwt.get('get-cdr-by-month?msisdn=' + this.searchPhone + '&month=' + monthFormatted).then((response) => {
          this.showLoading("none")
          if (response.data.code === 200) {
            this.cdrData = response.data.result.map((item, index) => ({
              ...item,
              NgayThang:moment(item.NgayThang).format("DD/MM/YYYY HH:mm")
            }));
            this.resultMessage = response.data.message;
            this.showErrSearch = this.cdrData.length === 0;
          } else {
            this.showErrSearch = true;
            this.resultMessage = "";
            this.$toast.error(response.data.message, {
              position: "top-right",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }
          console.log("getCdrByMonth", response.data);
        }).catch((error) => {
          this.showLoading("none")
          this.showErrSearch = true;
          this.resultMessage = "";
          console.log(error);
        });
      } else {
        this.showLoading("none")
        this.$refs.inputSearchPhone.focus()
        if (this.searchPhone === "") {
          this.$toast.error("Vui lòng nhập số thuê bao", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        } else {
          this.$toast.error("Số thuê bao chưa hợp lệ", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        }
      }
    },
    showLoading(options) {
      document.getElementById('loading-bg').style.display = options;
    },
  }
};
</script>

<style lang="scss" scoped>
.cdr-by-month {
  position: relative;
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__phone-number-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 80px;
  }

  &__phone-number-input {
    font-weight: 500;
    color: black;
    font-size: 14px;
    width: 200px;
  }

  &__month-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 50px;
  }

  &__month-input {
    font-weight: 500;
    color: black;
    font-size: 14px;
    width: 200px;
  }

  &__search-btn {
    border-radius: 40px;
  }

  &__history-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    th {
      background-color: #ED1F24;
      color: white;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }
}

.redButton {
  background-color: #ED1F24 !important;
  border-color: #ED1F24 !important;
}

@media screen and (max-width: 576px) {
  .cdr-by-month {
    &__phone-number-label {
      width: 100%;
    }

    &__phone-number-input {
      width: 100%;
    }

    &__month-label {
      width: 100%;
    }

    &__month-input {
      width: 100%;
    }
  }
}
</style>
